import React, { useState } from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDBodyText,
  FDPrimaryActionButton,
  FDBox,
  FDStack,
  FDContentContainer, FDSecondaryActionButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { dataAttrs } from 'Helpers/Testing';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';
import useEventTrackingLogEvent, {
  categories,
  eventSubTypes,
  eventTypes,
} from 'EventTracking/useEventTrackingLogEvent';
import useUserContext from 'Context/UserContext';

const Content = () => {
  const { logStandardizedEvent, logStandardizedEventFailureWithError } = useEventTrackingLogEvent();
  const [loading, setLoading] = useState(false);
  const { resource } = useMetaLayoutContext();
  const history = useHistory();
  const { loadPageContentLink, setPageContentCollection } = usePageContentContext();
  const canSubmit = resource.meta().canSubmit();
  const { isAgent, userResource } = useUserContext();

  const eventProperties = {
    resourceType: resource?.type(),
    isAgent,
    userId: userResource?.id(),
  };

  const handleDashboardClick = () => {
    logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickButton, 'submit step to dashboard', { eventProperties });
    history.push('/');
  };

  const handleSubmit = async () => {
    logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.submitStep, { eventProperties });
    setLoading(true);
    try {
      const updatedColl = await resource.submit();
      await setPageContentCollection(updatedColl);
      logStandardizedEvent(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.success, { eventProperties });
    } catch (e) {
      logStandardizedEventFailureWithError(categories.roadmapDeliverable, eventTypes.clickButton, eventSubTypes.failure, e, { eventProperties });
    } finally {
      setLoading(false);
    }
  };

  const handleSecondaryClick = canSubmit ? handleSubmit : handleDashboardClick;

  const showSeeOtherActions = resource.withRelationship(fr.relationships.seeOtherActions.name,
    (_) => true,
    () => false);

  return (
    <LottieLoadingLayout>
      <FDContentContainer maxWidth={'lg'}>
        <FDBox margin={400}>
          <FDStack direction={'column'} alignItems={'center'} spacing={3} justifyContent="flex-start">
            <MetaControlField attr={'title'} />
            <FDStack direction={'column'} spacing={2}>
              {resource.attr('subtitle')?.map((v) => (
                <FDBodyText key={v} value={v} align={'center'} />
              ))}
            </FDStack>
            {resource.withRelationship(fr.relationships.lottie.name,
              (rel) => (
                <FDBox paddingY={3}>
                  <LottieRel relationship={rel} width={'100%'} height={'100%'} />
                </FDBox>
              ),
              () => null)}
            <FDStack spacing={2}>
              {showSeeOtherActions ? (
                <FDSecondaryActionButton
                  loading={loading}
                  label={'Continue'}
                  onClick={() => handleSecondaryClick()}
                  {...dataAttrs('next-step')}
                />
              ) : (
                <FDPrimaryActionButton
                  loading={loading}
                  label={'Continue'}
                  onClick={() => handleSecondaryClick()}
                  {...dataAttrs('next-step')}
                />
              )}
              {showSeeOtherActions && (
                <FDPrimaryActionButton
                  loading={loading}
                  label={'See other actions'}
                  onClick={() => loadPageContentLink(resource.relationship(fr.relationships.seeOtherActions.name).link('related'))}
                  {...dataAttrs('see-other-actions-button')}
                />
              )}
            </FDStack>
          </FDStack>
        </FDBox>
      </FDContentContainer>
    </LottieLoadingLayout>
  );
};

export default Content;
